import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { checkFeatureSupport, initializePolyfills } from './utils/compatibility';

const initializeApp = async () => {
  try {
    // Initialize polyfills first
    await initializePolyfills();
    
    // Check feature support after polyfills are loaded
    const features = checkFeatureSupport();

    // Initialize service worker only in production and if supported
    if (features.serviceWorker && import.meta.env.PROD) {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js');
        console.log('SW registered:', registration);
      } catch (error) {
        console.error('SW registration failed:', error);
      }
    }

    // Mount React app
    const rootElement = document.getElementById('root');
    if (!rootElement) {
      throw new Error('Root element not found');
    }

    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  } catch (error) {
    console.error('App initialization failed:', error);
    // Show error to user
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.innerHTML = '<div style="padding: 20px; text-align: center;"><h1>Une erreur est survenue</h1><p>Veuillez rafraîchir la page ou réessayer plus tard.</p></div>';
    }
  }
};

initializeApp();